// Function loadHubGrid loads the HubGrid class by dynamically importing the js on demand if needed

export function loadHubGrid($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="HubGrid"]');

	if(!$wg) {
		// console.info('HubGrid: no widget found');
		return Promise.reject('HubGrid widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-hub-grid-chunk" */ '../widgets/hubGrid').then(wg => {

		const { HubGrid } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="HubGrid"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new HubGrid($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new HubGrid($wg);
		}


	}).catch(error => error+'An error occurred while loading the HubGrid widget');

}
